import { Colorways } from '@/types/constants';
import { getColorwayName } from '@/utils/formatters';

// Desktop constants
// Controls scroll distance per card (in viewport height units)
export const DESKTOP_SCROLL_HEIGHT_PER_CARD_VH = 60;

const DARK_COLORWAYS = new Set<Colorways>([
  Colorways.Inverse,
  Colorways.DarkestGreen,
  Colorways.DarkBlue,
  Colorways.DarkGreenGradient,
  Colorways.DarkGreenGradientLeftToRight,
  Colorways.DarkGreenAnimation,
  Colorways.AccentRed500,
  Colorways.AccentPink600,
  Colorways.Reserve,
]);

export function isDarkColorway(colorway: { name: Colorways } | Colorways): boolean {
  return DARK_COLORWAYS.has(getColorwayName(colorway));
}
